import React, { Component } from 'react';
import {array, string, func} from 'prop-types';

import ShowCase from '@components/ShowCase/ShowCase';
import Preview from '@components/ShowCase/Preview/Preview';
import Controls from '@components/ShowCase/Controls/Controls';

export default class ActionIconsShowcase extends Component {

  static propTypes = {
    component: func.isRequired,
    name: string,
    optionsGroup: array,
    backgrounds: array,
    codeTemplate: string,
    optionsFromState: array
  };

  render() {
    const { component, optionsGroup, backgrounds, codeTemplate, optionsFromState } = this.props;

    return (
      <ShowCase codeTemplate={codeTemplate}>
        <Preview>
          {(componentProps) => (
            component(componentProps)
          )}
        </Preview>
        <Controls optionsGroup={optionsGroup} optionsFromState={optionsFromState} backgrounds={backgrounds} />
      </ShowCase>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/elements/ActionIcons/ActionIconsShowcase.js